const normalizeLabel = (value: unknown): string =>
  String(value ?? '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, ' ')

export const isReportDateTimeLabel = (label: unknown): boolean =>
  normalizeLabel(label) === 'report date time'

export const formatReportDateTimeDisplay = (value?: string | null): string => {
  if (!value) return ''

  const raw = String(value).trim()
  const parsed = new Date(raw)
  if (Number.isNaN(parsed.getTime())) return raw

  const datePart = parsed.toLocaleDateString('en-GB')
  const timePart = parsed.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
  })
  return `${datePart} ${timePart}`
}

export const formatReportDateTimeFileToken = (value?: string | null): string => {
  const display = formatReportDateTimeDisplay(value)
  return display
    .replace(/[\/\\:]/g, '-')
    .replace(/\s+/g, '_')
    .replace(/[^A-Za-z0-9_.-]/g, '')
}

